import React from 'react';

interface Props {
  courseName: string;
  description?: string;
  totalSequences?: number;
  completedSequences?: number;
  onRestartCourse: () => void;
  onNewCourse: () => void;
}

const CourseComplete: React.FC<Props> = ({ 
  courseName, 
  description,
  totalSequences,
  completedSequences,
  onRestartCourse, 
  onNewCourse 
}) => {
  return (
    <div className="course-complete">
      <div className="completion-content">
        <h2>Course Complete!</h2>
        <h3>Congratulations on completing {courseName}!</h3>
        {description && <p>{description}</p>}
        {totalSequences && completedSequences && (
          <p>You completed {completedSequences} out of {totalSequences} sequences.</p>
        )}
        <p>You've successfully finished all sequences in this course.</p>
        
        <div className="completion-buttons">
          <button 
            className="restart-button"
            onClick={onRestartCourse}
          >
            Restart Course
          </button>
          <button 
            className="new-course-button"
            onClick={onNewCourse}
          >
            Import New Course
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseComplete; 